import CustomButton from 'components/CustomInput/Button';
import React, { useEffect, useState } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';
import TextHeader from 'components/CustomText/TextHeader';
import { Grid, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomTextField from 'components/Input/CustomTextField';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import CustomTable from 'components/CustomTable';
import PopupInput from 'components/Application/TeamMemberForm/PopupInput';
import CustomCheckbox from 'components/CustomCheckbox';
import useUploadDocData from './useUploadDocData';
import GeneralPostApprovalLayout from 'components/GeneralPostApprovalLayout';
import {
    SAVE_MISCELLANEOUS,
    GET_MISCELLANEOUS,
    SUBMIT_MISCELLANEOUS,
    SET_MISCELLANEOUS_REPORT,
    UP_DATA_INITIAL,
} from 'store/key';
import { GENERAL_SAVE_SUCCESS, GENERAL_SUBMIT_SUCCESS, ERROR_MAX_LENGTH } from 'utility/frontendMessage';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import useQuery from 'hooks/useQuery';
import { MISCELLANEOUS_REPORT } from 'utility/postApprovalLookUp';
import TipsIcon from 'components/TipsIcon';
import { getTimeWithTimeZone } from 'utility/general';
import { SEvenRow } from 'style/CommonStyledComponent';
import { postApprovalPermissionChecking, produce, waitUntilFormUpdate } from 'utility/general';

const useStyles = makeStyles((theme) => ({
    page: {
        padding: 15,
    },
    itemContent: {
        paddingTop: 20,
    },
    subItem: {
        paddingTop: 10,
    },
    textSubHeader: {
        paddingBottom: 10,
    },
    leftColumn: {
        paddingRight: 30,
    },
    rightColumn: {
        paddingLeft: 30,
    },
    italicText: {
        paddingTop: 5,
        fontStyle: 'italic',
    },
}));

const MiscellaneousReport = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    let appId = useQuery('appId');
    if (appId) {
        appId = Number(appId);
    }
    const reportId = useQuery('reportId');
    const siteId = useQuery('siteId');
    const location = useLocation();
    const history = useHistory();

    const miscellaneousReport = useSelector((state) => state.miscellaneousReport);
    const remoteDetail = miscellaneousReport.remoteDetail;
    const isFormCreate = !reportId;
    const rows = miscellaneousReport.rows;
    const isLoading = miscellaneousReport.isLoading;
    const isNotYetStarted = miscellaneousReport.remoteDetail.isNotYetStarted;
    const approvalDecisionDate = miscellaneousReport.remoteDetail.decisionDate;
    const forceErrorDisplay = miscellaneousReport.forceErrorDisplay;
    const status = miscellaneousReport.remoteDetail?.lastStatus;
    const docType = MISCELLANEOUS_REPORT;
    const hasCCOAction = miscellaneousReport.remoteDetail.hasCCOAction;

    const signedFileId = miscellaneousReport.remoteDetail.signedFileId;
    const signedFileName = miscellaneousReport.remoteDetail.signedFileName;

    const isPermission = postApprovalPermissionChecking({ status, reportData: miscellaneousReport.remoteDetail });
    let isViewOnly = !isPermission;
    const typeOfSubmittedInformation = miscellaneousReport?.remoteDetail?.typeOfSubmittedInformation?.split(',') || [];
    const {
        columns: uploadDocColumns,
        defaultUploadDocFormList,
        onUploadDocEditSubmit,
        handleUploadDocUpdate,
        handleUploadDocDelete,
        showUploadDocDialog,
        setShowUploadDocDialog,
    } = useUploadDocData({ miscellaneousReport, rows });

    const [actualStudyStartDateValid, setActualStudyStartDateValid] = useState(true);
    const [submittedInformationTypeValid, setSubmittedInformationTypeValid] = useState(true);
    const [submittedInformationValid, setSubmittedInformationValid] = useState(true);
    const [remarkOfOthersValid, setRemarkOfOthersValid] = useState(true);
    const [remarkOfOthers, setRemarkOfOthers] = useState(miscellaneousReport?.remoteDetail?.remarkOfOthers);
    const [signedUpload, setSignedUpload] = useState({ fileName: '', key: null });
    const [maxLengthValidation, setMaxLengthValidation] = useState({});

    useEffect(() => {
        miscellaneousReport.remoteDetail.remarkOfOthers = null;
        getMiscellaneousDetail();
        // eslint-disable-next-line
    }, [reportId]);

    // eslint-disable-next-line
    useEffect(() => {
        if (typeOfSubmittedInformation.includes('others')) {
            setRemarkOfOthers(miscellaneousReport?.remoteDetail?.remarkOfOthers);
        }
    });

    useEffect(() => {
        if (signedFileId && signedFileName) {
            setSignedUpload({ fileName: signedFileName, key: signedFileId });
        } else {
            setSignedUpload({ fileName: '', key: null });
        }
    }, [signedFileId, signedFileName]);

    const updateMaxLength = (key, value) => {
        setMaxLengthValidation(
            produce((draft) => {
                draft[key] = value;
            }),
        );
    };

    const checkIsFormDataChanged = () => {
        if (
            miscellaneousReport.remoteDetail.addSupplements.length ||
            miscellaneousReport.remoteDetail.deleteSupplements.length
        ) {
            return true;
        }
        let isChanged = false;
        for (let key in miscellaneousReport.oldData) {
            if (miscellaneousReport.oldData[key] !== miscellaneousReport.remoteDetail[key]) {
                isChanged = true;
                break;
            }
        }
        return isChanged;
    };

    const getMiscellaneousDetail = () => {
        dispatch({
            type: GET_MISCELLANEOUS,
            payload: {
                docType,
                reportId,
                appId,
                isFormCreate,
                siteId,
                onPermissionError: () => {
                    history.push('/');
                },
            },
        });
    };

    const changeSubmittedInformationType = (key, checked) => {
        let copyList = [...typeOfSubmittedInformation];
        if (checked) {
            copyList.push(key);
        } else {
            const index = copyList.findIndex((item) => item === key);
            if (index !== -1) {
                copyList.splice(index, 1);
            }
        }
        if (!copyList.includes('others')) {
            setRemarkOfOthers(null);
            miscellaneousReport.remoteDetail.remarkOfOthers = null;
        }
        handleChange('typeOfSubmittedInformation', copyList.toString());
    };

    const handleChange = (name, value) => {
        let data = { ...remoteDetail, [name]: value };
        dispatch({
            type: UP_DATA_INITIAL,
            payload: {
                key: 'remoteDetail',
                value: data,
            },
        });
    };

    const changeNotYetStarted = (e) => {
        const value = e.target.checked;
        if (value) {
            dispatch({
                type: SET_MISCELLANEOUS_REPORT,
                payload: {
                    remoteDetail: {
                        ...remoteDetail,
                        actualStudyStartDate: null,
                        isNotYetStarted: value,
                    },
                },
            });
        } else {
            handleChange('isNotYetStarted', value);
        }
    };

    const checkSubmitFormValid = (miscellaneousReport) => {
        let valid = true;
        dispatch({
            type: SET_MISCELLANEOUS_REPORT,
            payload: {
                forceErrorDisplay: true,
            },
        });
        if (!actualStudyStartDateValid) valid = false;
        if (!submittedInformationTypeValid) valid = false;
        if (!submittedInformationValid) valid = false;
        if (!remarkOfOthersValid) valid = false;

        return {
            valid: valid,
        };
    };

    const checkSaveFormValid = () => {
        const hasMaxLengthError = Object.values(maxLengthValidation).includes(false);

        return {
            valid: !hasMaxLengthError,
            msg: ERROR_MAX_LENGTH,
        };
    };

    const onSubmit = async () => {
        dispatch({
            type: SUBMIT_MISCELLANEOUS,
            payload: {
                reportId,
                appId,
                isFormCreate,
                signedFileId: signedUpload.key,
                siteId,
                callback: () => {
                    showDialog({
                        description: GENERAL_SUBMIT_SUCCESS,
                        disableCancelButton: true,
                    });
                    history.push('/');
                },
            },
        });
    };

    const handleFormCreate = async ({ callback }) => {
        const { pathname } = location;

        const hasChange = await waitUntilFormUpdate();
        if (hasChange) {
            return;
        }
        dispatch({
            type: SAVE_MISCELLANEOUS,
            payload: {
                reportId,
                appId,
                isFormCreate,
                signedFileId: signedUpload.key,
                siteId,
                callback: (newReportId) => {
                    showDialog({
                        description: GENERAL_SAVE_SUCCESS,
                        disableCancelButton: true,
                    });

                    if (isFormCreate) {
                        callback?.(newReportId);
                        history.push(`${pathname}?reportId=${newReportId}`);
                    } else {
                        getMiscellaneousDetail();
                        callback?.();
                    }
                },
            },
        });
    };

    return (
        <GeneralPostApprovalLayout
            type={docType}
            isFormCreate={isFormCreate}
            onCreate={handleFormCreate}
            onSubmit={onSubmit}
            isLoading={isLoading}
            isViewOnly={isViewOnly}
            status={status}
            reportId={reportId}
            hasCCOAction={hasCCOAction}
            isPermission={isPermission}
            signedUpload={signedUpload}
            onSignedDocumentUploaded={(result) => {
                setSignedUpload(result);
            }}
            checkIsFormDataChanged={checkIsFormDataChanged}
            checkSubmitFormValid={checkSubmitFormValid}
            checkSaveFormValid={checkSaveFormValid}
            siteInfo={remoteDetail?.siteInstruction}
        >
            {showUploadDocDialog && (
                <PopupInput
                    title={'Upload Supplementary Document'}
                    height="500px"
                    width="700px"
                    alignItems={'center'}
                    defaultFormList={defaultUploadDocFormList}
                    editRow={onUploadDocEditSubmit}
                    setOpenPopup={setShowUploadDocDialog}
                    tableList={rows}
                    onSubmit={handleUploadDocUpdate}
                    isUpload={true}
                />
            )}
            {isLoading ? (
                <div
                    style={{
                        height: 300,
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingIndicator />
                </div>
            ) : (
                <>
                    <Grid>
                        <TextHeader style={{ textAlign: 'center', marginBottom: 10 }}>
                            Miscellaneous Report Form
                        </TextHeader>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader className={classes.textSubHeader}>1. Basic Information</TextSubHeader>

                        <SEvenRow style={{ marginTop: 10 }}>
                            <div>
                                <div>Scientific Title:</div>
                                <div>{remoteDetail?.scientificTitle}</div>
                            </div>
                        </SEvenRow>
                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>IRB/REC Ref. No.:</div>
                                <div>{remoteDetail?.refNo}</div>
                            </div>
                            <div>
                                <div>Protocol No.:</div>
                                <div>{remoteDetail?.protocolNo}</div>
                            </div>
                        </SEvenRow>
                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div>Coordinating Investigator:</div>
                                <div>{remoteDetail?.ci}</div>
                            </div>
                            <div>
                                <div>Anticipated Study End Date:</div>
                                <div>
                                    {remoteDetail?.antipicateStudyEndDate
                                        ? getTimeWithTimeZone(remoteDetail.antipicateStudyEndDate).format('YYYY-MM-DD')
                                        : '-'}
                                </div>
                            </div>
                        </SEvenRow>

                        <SEvenRow style={{ marginTop: 20 }}>
                            <div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    Actual Study Start Date:
                                    <TipsIcon
                                        title={['Before current date and not earlier than approval decision date']}
                                    />
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ width: 200 }}>
                                        <CustomDatePicker
                                            value={remoteDetail?.actualStudyStartDate}
                                            onChange={(date) => handleChange('actualStudyStartDate', new Date(date))}
                                            disabled={isViewOnly || isNotYetStarted}
                                            minDate={new Date(approvalDecisionDate).getTime()}
                                            maxDate={new Date().getTime()}
                                            validators={isNotYetStarted ? [] : ['isRequired']}
                                            forceErrorDisplay={forceErrorDisplay}
                                            isValidValue={(isValid) => setActualStudyStartDateValid(isValid)}
                                        />
                                    </div>
                                    <Checkbox
                                        size="small"
                                        color="primary"
                                        disabled={isViewOnly}
                                        onChange={changeNotYetStarted}
                                        checked={remoteDetail ? remoteDetail.isNotYetStarted : null}
                                    />
                                    Not yet started
                                </div>
                            </div>
                        </SEvenRow>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>2. Type of Submitted Information</TextSubHeader>
                        <Grid container className={classes.subItem}>
                            <CustomCheckbox
                                allowUnCheckAll
                                isRequired
                                disabled={isViewOnly}
                                defaultData={[
                                    { key: 'newInformation', display: 'New Information' },
                                    { key: 'others', display: 'Others (Please specify)' },
                                ]}
                                value={typeOfSubmittedInformation}
                                validators={['isRequired']}
                                onItemChange={changeSubmittedInformationType}
                                forceErrorDisplay={forceErrorDisplay}
                                isValidValue={(isValid) => {
                                    setSubmittedInformationTypeValid(isValid);
                                }}
                            />
                            <Grid className={classes.subItem} container>
                                <CustomTextField
                                    label={`Remark of others`}
                                    value={remarkOfOthers}
                                    onChange={(e) => {
                                        setRemarkOfOthers(e.target.value);
                                        handleChange('remarkOfOthers', e.target.value);
                                    }}
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={typeOfSubmittedInformation.includes('others') ? ['isRequired'] : []}
                                    isTextArea
                                    textAreaMinRow={3}
                                    disabled={isViewOnly || !typeOfSubmittedInformation.includes('others')}
                                    maxLength={255}
                                    isValidValue={(isValid, isMaxLengthValid) => {
                                        setRemarkOfOthersValid(isValid);
                                        updateMaxLength('remarkOfOthers', isMaxLengthValid);
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>3. List of Submitted Information</TextSubHeader>
                        <Grid className={classes.subItem} container>
                            <CustomTextField
                                disabled={isViewOnly}
                                label={`List of Submitted Information`}
                                value={remoteDetail?.listOfSubmittedInformation}
                                onChange={(e) => {
                                    handleChange('listOfSubmittedInformation', e.target.value);
                                }}
                                forceErrorDisplay={forceErrorDisplay}
                                validators={['isRequired']}
                                isTextArea
                                textAreaMinRow={8}
                                maxLength={3000}
                                isValidValue={(isValid, isMaxLengthValid) => {
                                    setSubmittedInformationValid(isValid);
                                    updateMaxLength('listOfSubmittedInformation', isMaxLengthValid);
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid className={classes.itemContent}>
                        <TextSubHeader>Upload Supplementary Document</TextSubHeader>
                        {!isViewOnly && (
                            <CustomButton
                                disabled={isViewOnly}
                                style={{ marginTop: 8 }}
                                onClick={() => setShowUploadDocDialog(true)}
                            >
                                Add
                            </CustomButton>
                        )}
                        <Grid className={classes.subItem}>
                            <CustomTable
                                disabled={isViewOnly}
                                columns={uploadDocColumns}
                                rows={rows}
                                isDeleteAllow={!isViewOnly}
                                onDelete={handleUploadDocDelete}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
        </GeneralPostApprovalLayout>
    );
};

export default MiscellaneousReport;
